// Create Blog Post
export const CREATE_BLOG_POST_REQUEST = "CREATE_BLOG_POST_REQUEST";
export const CREATE_BLOG_POST_SUCCESS = "CREATE_BLOG_POST_SUCCESS";
export const CREATE_BLOG_POST_FAIL = "CREATE_BLOG_POST_FAIL";

// Get All Blog Posts
export const GET_ALL_BLOG_POSTS_REQUEST = "GET_ALL_BLOG_POSTS_REQUEST";
export const GET_ALL_BLOG_POSTS_SUCCESS = "GET_ALL_BLOG_POSTS_SUCCESS";
export const GET_ALL_BLOG_POSTS_FAIL = "GET_ALL_BLOG_POSTS_FAIL";

// Get Blog Post Details
export const GET_BLOG_POST_DETAILS_REQUEST = "GET_BLOG_POST_DETAILS_REQUEST";
export const GET_BLOG_POST_DETAILS_SUCCESS = "GET_BLOG_POST_DETAILS_SUCCESS";
export const GET_BLOG_POST_DETAILS_FAIL = "GET_BLOG_POST_DETAILS_FAIL";

// Update Blog Post
export const UPDATE_BLOG_POST_REQUEST = "UPDATE_BLOG_POST_REQUEST";
export const UPDATE_BLOG_POST_SUCCESS = "UPDATE_BLOG_POST_SUCCESS";
export const UPDATE_BLOG_POST_FAIL = "UPDATE_BLOG_POST_FAIL";

// Delete Blog Post
export const DELETE_BLOG_POST_REQUEST = "DELETE_BLOG_POST_REQUEST";
export const DELETE_BLOG_POST_SUCCESS = "DELETE_BLOG_POST_SUCCESS";
export const DELETE_BLOG_POST_FAIL = "DELETE_BLOG_POST_FAIL";

// Clear errors or messages
export const CLEAR_BLOG_ERRORS = "CLEAR_BLOG_ERRORS";
export const CLEAR_BLOG_MESSAGE = "CLEAR_BLOG_MESSAGE";
